import { EnumSchema } from '../metadata-schema';

export const TussentijdseUitstroomVSOStatus: EnumSchema = {
	"type": "string",
	"title": "TussentijdseUitstroomVSOStatus",
	"enum": [
		"Informatie volledig",
		"Geen school van bestemming geregistreerd",
		"Onbekende schoolsoort SvB",
		"Niet uitgeschreven",
		"Registratie niet beëindigd",
		"Geen tussentijdse uitstroom"
	]
};
